import produce from 'immer';
import {
	ACTIVATE_3DSECURE,
	CREATE_PAYMENT_CARD,
	CREATE_PAYMENT_CARD_ERROR,
	CREATE_PAYMENT_CARD_PENDING,
	DELETE_PAYMENT_CARD_ERROR,
	DELETE_PAYMENT_CARD_FULFILLED,
	DELETE_PAYMENT_CARD_PENDING,
	GET_USES_NEW_FLOW,
	GET_USES_NEW_FLOW_ERROR,
	GET_USES_NEW_FLOW_PENDING,
	INITIALIZE_PAYMENT_CARD,
	INITIALIZE_PAYMENT_CARD_ERROR,
	INITIALIZE_PAYMENT_CARD_PENDING,
	PAYMENT_ERROR,
	PAYMENT_FULFILLED,
	PAYMENT_PENDING,
} from '../constants/actions/paymentActions';
import { LOGOUT_FULFILLED } from '../constants/actions/userProfileActions'; // Import the logout action type
import IPaymentReducer from '../interfaces/reducers/paymentReducer';

const initialValues: IPaymentReducer = {
	paymentCardLoading: true,
	paymentCardError: '',
	paymentCard: null,
	payError: '',
	is3DSecureActive: false,
	html3DSecure: '',
	accountUsesNewFlowLoading: false,
	accountUsesNewFlowError: null,
	accountUsesNewFlow: null,
};

const paymentReducer = produce((draft: IPaymentReducer, action) => {
	switch (action.type) {
		case INITIALIZE_PAYMENT_CARD: {
			// eslint-disable-next-line prefer-destructuring
			draft.paymentCard = action.payload.paymentCard.length === 0 ? null : action.payload.paymentCard[0];
			draft.paymentCardLoading = false;
			break;
		}
		case INITIALIZE_PAYMENT_CARD_PENDING: {
			draft.paymentCardLoading = true;
			break;
		}
		case INITIALIZE_PAYMENT_CARD_ERROR: {
			draft.paymentCardLoading = false;
			break;
		}
		case CREATE_PAYMENT_CARD: {
			draft.is3DSecureActive = false;
			draft.html3DSecure = '';
			draft.paymentCard = action.payload.paymentCard;
			break;
		}
		case ACTIVATE_3DSECURE: {
			draft.is3DSecureActive = true;
			draft.html3DSecure = action.payload.html;
			break;
		}
		case CREATE_PAYMENT_CARD_PENDING: {
			draft.paymentCardError = '';
			break;
		}
		case CREATE_PAYMENT_CARD_ERROR: {
			draft.paymentCardError = action.payload;
			break;
		}
		case DELETE_PAYMENT_CARD_FULFILLED: {
			draft.paymentCard = null;
			break;
		}
		case DELETE_PAYMENT_CARD_PENDING: {
			break;
		}
		case DELETE_PAYMENT_CARD_ERROR: {
			break;
		}
		case PAYMENT_PENDING: {
			draft.payError = '';
			break;
		}
		case PAYMENT_FULFILLED: {
			break;
		}
		case PAYMENT_ERROR: {
			draft.payError = action.payload;
			break;
		}
		case GET_USES_NEW_FLOW_PENDING: {
			draft.accountUsesNewFlowLoading = true;
			draft.accountUsesNewFlowError = null;
			break;
		}
		case GET_USES_NEW_FLOW: {
			draft.accountUsesNewFlowLoading = false; // teya or valitor
			draft.accountUsesNewFlow = action.payload.accountUsesNewFlow;
			break;
		}
		case GET_USES_NEW_FLOW_ERROR: {
			draft.accountUsesNewFlowLoading = false;
			draft.accountUsesNewFlowError = action.payload ?? 'Failed to fetch';
			break;
		}

		case LOGOUT_FULFILLED: {
			// Reset the state on logout
			return initialValues;
		}
		default:
			break;
	}
}, initialValues);

export default paymentReducer;
